<template>
<div>
  <div :class="{ 'container-fluid': !public_view, 'post': true, }">

    <div class="row" v-if="state=='ready'">
      <div class="col-sm-12 col-md-11">
        <div class="post-header">
          <img :src="content.header_image" />
          <div class="text">
            <h1>{{content.title}}</h1>
            <p>{{parsedDate}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row text-content" v-if="state=='ready'">
      <div class="col-sm-12 col-md-7 ">
        <div v-if="content.sermon_summary" class="text-section">
          <h4>Main idea</h4>
          {{content.sermon_summary}}
        </div>

        <div class="text-section">
          <hr v-if="content.sermon_summary" />
          <h4 v-if="content.sermon_summary">Summary</h4>
          {{content.content}}
        </div>

        <div class="text-section" v-if="content.action_steps">
          <h4>Action Steps</h4>
          <div class="item action-steps" :key="key" v-for="item, key in content.action_steps">
            {{item}}
          </div>
        </div>

        <div class="text-section" v-if="content.reflective_questions">
          <h4>Reflective Questions</h4>
          <div class="item questions" :key="key" v-for="item, key in content.reflective_questions">
            {{item}}
          </div>
        </div>

      </div>

      <div class="col-sm-12 col-md-4">
        <h4>Support Scriptures</h4>
        <div class="support-scripture" :key="key" v-for="item, key in content.scripture_references">
          {{item}}
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import moment from "moment"

export default {
  name: 'ContentViewer',
  components: {
  },
  props: {
    blog_data: Object,
    public_view: Boolean
  },
  data () {
    return {
      state: "loading",
      slug: null,
      content_slug: null,
      content: null
    }
  },
  methods: {
    handleRouteChange (route) {
      if (route) {
        this.content_slug = route.params.content_slug
      }
      else if (!this.content_slug && this.blog_data) {
        this.content_slug = this.blog_data.slug
      }
      this.updateModel()
    },
    async updateModel () {
      this.state = "loading"
      if (!this.content_slug) return
      var result = await fetch(`/api/view/content/${this.content_slug}/`)
      this.content = await result.json()
      try {
        this.content.scripture_references = JSON.parse(this.content.scripture_references)
      } catch {
      // @no-empty
      }
      try {
        this.content.action_steps = JSON.parse(this.content.action_steps)
      } catch {
      // @no-empty
      }
      try {
        this.content.reflective_questions = JSON.parse(this.content.reflective_questions)
      } catch {
      // @no-empty
      }
      this.state = "ready"
    },
  },
  computed: {
    parsedDate () {
      if (!this.content.publish_date) return null
      return moment(this.content.publish_date).format("LL")
    }
  },
  watch: {
    $route (to) {
      this.handleRouteChange(to)
    }
  },
  async created () {
    this.handleRouteChange(this.$route)
    this.updateModel()
  }
}
</script>
<style scoped>
  .post {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
  }
  .post-header {
    border-radius: 20px 20px 0 0;
    height: 400px;
    padding: 0;
    margin-top: 2em;
    position: relative;
    background: black;
  }

  .post-header .text *{
    margin: 0;
    padding: 0;
    color: white;
  }
  .post-header .text {
    position: absolute;
    bottom: 0px;
    padding: 20px;
  }
  .post-header img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.7;
    border-radius: 20px 20px 0 0;
  }

  .row.text-content {
    white-space: pre-line;
  }
  .row.text-content div.text-section {
    width: 100%;
    padding: 20px;
  }

  .text-section .item {
    margin: 10px 0;
    padding: 5px;
    border-bottom: 1px solid #aaa;
  }

  .support-scripture {
    font-style: italic;
    margin: 10px 0;
    font-weight: bold;
  }
</style>
